import React from 'react';
import {
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid
} from 'recharts';
import PropTypes from 'prop-types';
import CustomLegend from 'components/GraphHelper/CustomLegend';
import GraphNoData from '../../assets/images/graphNoData.png';
import './AreaChartGraph.scss';
import AreaChartGraphTooltip from './AreaChartGraphTooltip';

function AreaChartGraph(props) {
  const { data, xDataKey, graphFailureKey, graphSucessKey } = props;
  return (
    <div className="line-chart-graph">
      <ResponsiveContainer className="graph-main-container">
        {data.length > 0 ? (
          <LineChart
            width="100%"
            height={400}
            data={data}
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey={xDataKey}
              name="sucess"
              orientation="bottom"
              padding="gap"
              fontSize="13px"
              minTickGap={20}
              label={{
                value: 'Date Range',
                angle: 0,
                offset: -30,
                position: 'insideBottom',
                fill: 'black'
              }}
              stroke="black" // Axis line & tick color
              tick={{ fill: 'black' }} // Tick label styling
              axisLine={{ stroke: 'black' }} // Explicitly set axis line color
              tickLine={{ stroke: 'black' }} // Tick mark line color
            />
            <YAxis
              fontSize="13px"
              label={{
                value: 'Transaction',
                angle: -90,
                offset: 0,
                position: 'outsideLeft',
                dy: -40,
                dx: -40,
                fontSize: 15,
                fill: 'black'
              }}
              stroke="black" // Axis line & tick color
              tick={{ fill: 'black' }} // Tick label styling
              axisLine={{ stroke: 'black' }} // Explicitly set axis line color
              tickLine={{ stroke: 'black' }} // Tick mark line color
            />
            <Tooltip content={AreaChartGraphTooltip} />
            <Legend content={<CustomLegend />} />

            <Line
              dataKey={graphSucessKey}
              name="Success"
              stroke="#009D19" // light green line
              fill="url(#colorPv)"
              dot={{ r: 4, fill: '#009D19', stroke: '#009D19' }} // filled green circle
              activeDot={{ r: 4, fill: '#009D19', stroke: '#009D19' }}
            />

            <Line
              dataKey={graphFailureKey}
              name="Failure"
              stroke="#DC143C" // red line
              fill="url(#colorUv)"
              dot={{ r: 4, fill: '#DC143C', stroke: '#DC143C' }} // filled red circle
              activeDot={{ r: 4, fill: '#DC143C', stroke: '#DC143C' }}
            />
          </LineChart>
        ) : (
          <div className="graph-no-data">
            <img src={GraphNoData} width="320px" height="170px" alt="seems like no data" />
          </div>
        )}
      </ResponsiveContainer>
    </div>
  );
}

AreaChartGraph.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      txn_date: PropTypes.string,
      txn_failure: PropTypes.number,
      txn_success: PropTypes.number
    })
  ),
  xDataKey: PropTypes.string,
  graphFailureKey: PropTypes.string,
  graphSucessKey: PropTypes.string
};

AreaChartGraph.defaultProps = {
  data: {},
  xDataKey: '',
  graphFailureKey: '',
  graphSucessKey: ''
};

export default AreaChartGraph;
